<div class="flex">
  <input matInput autocomplete="new-password" maxlength="50" placeholder="Password"
         [type]="hidePassword ? 'password' : 'text'"
         [disabled]="disabled"
         [required]="required"
         [(ngModel)]="value"
         (click)="stateChanges.next()"
         (keydown)="changeState()"
         (change)="onPasswordFieldChange()"
         (focus)="onPasswordFieldFocus($event)"
         (blur)="onPasswordFieldBlur($event)"
         (paste)="onPasswordFieldPaste($event)"
         (cdkAutofill)="autofilled = $event.isAutofilled"
         [attr.aria-label]="placeholder"
          #inputElement>

  <mat-icon matSuffix class="gray-color cursor-pointer" tabindex="0" aria-hidden="false" role="button"
            [attr.aria-pressed]="!hidePassword"
            [attr.aria-label]="hidePassword ? 'Show password' : 'Hide password'"
            (click)="togglePasswordReveal()"
            (keydown)="togglePasswordReveal($event)">
      {{hidePassword ? 'visibility_off' : 'visibility'}}
  </mat-icon>
</div>
